<!-- 模拟交易领涨股 -->
<template>
  <div class="jylzgMore" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="jylzgMore-nav">
      <van-nav-bar title="模拟交易领涨股" left-arrow @click-left="onClickLeft" />
    </div>

    <div class="content">
      <p class="hint">热门模拟交易持仓中涨幅最高的股票</p>

      <ul class="lzg_list">
        <li v-for="(item, index) in lzgList" :key="item.stkCode" class="lzg_list_li">
          <div class="top">
            <div class="left" @click="gotoDetail(item.stkCode)">
              <span
                class="index"
                :style="
                  index === 0
                    ? { 'background-image': `url(${require(`@/assets/image/phb1_2x.png`)}` }
                    : index === 1
                    ? { 'background-image': `url(${require(`@/assets/image/phb2_2x.png`)}` }
                    : index === 2
                    ? { 'background-image': `url(${require(`@/assets/image/phb3_2x.png`)}` }
                    : index > 2
                    ? { 'background-image': `url(${require(`@/assets/image/phb4_2x.png`)}` }
                    : ''
                "
                >{{ index + 1 }}</span
              >

              <div class="l_r">
                <p class="name">{{ item.name }}</p>
                <p class="code">{{ item.stkCode.slice(2, 9) }}</p>
              </div>
            </div>

            <div class="right">
              <span class="involvedCount">入选{{ item.involvedCount }}个</span>
              <span class="rate" :class="[judgeBgColor(item.rate)]">{{
                toFixedNum(item.rate, 2, '%')
              }}</span>

              <p class="operate" v-if="clickIndex != index" @click="handleClickCard(index)">展开</p>
              <p class="operate" v-else @click="handleClickCard(index)">收起</p>
            </div>
          </div>

          <ul class="bottom_ul" v-if="clickIndex === index">
            <li v-for="item2 in item.hotTopVos" :key="item2.capitalId" @click="goMnDetail(item2)">
              <p class="t_name">{{ item2.name }}</p>
              <van-row gutter="4">
                <van-col span="8">
                  <div class="block">
                    <p class="zf" :class="[judgeColor(item2.totalRisk)]">
                      {{ toFixedNum(item2.totalRisk * 100, 2, '%') }}
                    </p>
                    <p class="name">累计收益</p>
                  </div>
                </van-col>
                <van-col span="8">
                  <div class="block">
                    <p class="zf" :class="[judgeColor(item2.todayRisk)]">
                      {{ toFixedNum(item2.todayRisk * 100, 2, '%') }}
                    </p>
                    <p class="name">今日收益</p>
                  </div>
                </van-col>
                <van-col span="8">
                  <div class="block">
                    <p class="zf zf_black">{{ toFixedNum(item2.maxRetreatRate * 100, 2, '%') }}</p>
                    <p class="name">最大回撤</p>
                  </div>
                </van-col>
              </van-row>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { getHotMokpanelLeading } from '@/api/index.js';
import { judgeBgColor, judgeColor, toFixedNum,compareVersions } from '@/utils/format';
import mixin from '@/mixins/index.js';

export default {
  name: 'JylzgMore',
  mixins: [mixin],
  props: [],

  data() {
    return {
      lzgList: [],
      clickIndex: null,
      interval: null,
      isVip: false
    };
  },
  filters: {},
  created() {},
  watch: {
    '$store.state.isVip': {
      handler(newValue) {
        this.isVip = newValue;
      },
      immediate: true // 立即执行一次
    }
  },
  async mounted() {
    this.getHotMokpanelLeadingFun();

    this.interval = setInterval(() => {
      this.getHotMokpanelLeadingFun();
    }, 1000 * 60);
  },
  methods: {
    judgeBgColor,
    judgeColor,
    toFixedNum,
    compareVersions,

    onClickLeft: function () {
      this.$router.go(-1);
    },

    handleClickCard(index) {
      if (this.clickIndex === index) {
        // 如果当前索引已经是展开状态，则隐藏
        this.clickIndex = null;
      } else {
        // 否则展开
        this.clickIndex = index;
      }
    },

    getHotMokpanelLeadingFun: function () {
      var params = {};
      return getHotMokpanelLeading(params)
        .then((res) => {
          this.lzgList = res.data;
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    cancelBasis: function (e) {
      this.takeShow = e;
    },

    // 跳转模拟详情
    goMnDetail: function (item) {
      // 判断是否是 vip
      if(this.isVip == false && compareVersions(this.$route.query.version , 9.92)) {
        let appJson = {
          DialogType: "basic",
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorTYPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else if (this.isVip == false && compareVersions(this.$route.query.version , 9.71) ) {
        // 如果不是VIP用户,弹出VIP提示
        let appJson = {
          channel: 'yinzi',
          dzhadid: '0704'
        };
        DzhAppJs.callAppWithChannelAndJsonAndCallbackFunc(
          'factorNoVipPerDialog',
          JSON.stringify(appJson),
          ''
        );
      } else {
        location.href = '/mnDetail?DZHSPECIAL=4325641&type=hot&zj_id=' + item.capitalId;
      }
    },

    gotoDetail: function (code) {
      this.gogufs(code);
    }
  },
  beforeDestroy() {
    clearInterval(this.interval);
  }
};
</script>
<style lang="less" scoped>
.jylzgMore {
  .jylzgMore-nav {
    ::v-deep {
      .van-hairline--bottom::after {
        display: none;
      }
      .van-nav-bar {
        padding-top: 40px;
        background: none;
      }
      .van-nav-bar__left,
      .van-nav-bar__right {
        padding: 0 16px;
      }

      .van-icon,
      .van-nav-bar__title {
        color: #333;
      }
    }
  }
  .content {
    .hint {
      border-radius: 4px;
      background: #f7f7fc;
      color: #999;
      font-size: 12px;
      padding: 6px 12px;
      margin: 4px 16px;
    }
    .lzg_list {
      padding: 6px 0;
      overflow-y: auto;
      height: calc(100vh - 123px);
      .lzg_list_li {
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 4px 16px;
          .left,
          .right {
            display: flex;
            align-items: center;
          }
          .left {
            .index {
              width: 16px;
              height: 16px;
              flex-shrink: 0;
              border-radius: 4px;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 12px;
              color: #fff;
            }
            .l_r {
              margin-left: 12px;

              .name {
                color: #555;
                font-size: 16px;
                font-weight: 500;
              }
              .code {
                color: #999;
                font-size: 12px;
              }
            }
          }
          .right {
            font-size: 12px;
            .involvedCount {
              color: #999;
            }
            .rate {
              color: #fff;
              border-radius: 4px;
              width: 52px;
              height: 22px;
              line-height: 22px;
              text-align: center;
              margin: 0 8px;
            }
            .operate {
              color: #286df7;
            }
          }
        }
        .bottom_ul {
          background: #f7f8fa;
          padding: 8px;
          li {
            border-radius: 6px;
            background: #fff;
            padding: 8px 12px;
            margin-bottom: 8px;
            .t_name {
              color: #555;
              font-size: 16px;
              font-weight: 500;
              margin-bottom: 4px;
            }
            .block {
              border-radius: 4px;
              background: #f7f8fa;
              text-align: center;
              padding: 8px 0;
              .zf {
                font-size: 14px;
                font-weight: 600;
                color: #555;
              }
              .name {
                margin-top: 2px;
                color: #999;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  background: #1a1c26;
  ::v-deep {
    .van-icon,
    .van-nav-bar__title {
      color: #fff !important;
    }
  }
  .content {
    .hint {
      background: #272935;
      color: #6b7687;
    }
    .lzg_list {
      .name {
        color: #aab9d1 !important;
      }
      .code {
        color: #6b7687 !important;
      }
      .involvedCount {
        color: #6b7687 !important;
      }
      .operate {
        color: #3b85fe !important;
      }
      .bottom_ul {
        background: #0c0f13 !important;
        li {
          background: #181a23 !important;
          .t_name {
            color: #aab9d1 !important;
          }
          .block {
            background: #1d202d !important;
            .zf_black {
              color: #aab9d1 !important;
            }
            .name {
              color: #6b7687;
            }
          }
        }
      }
    }
  }
}
</style>
